<ng-container *transloco="let t;">
    <div class="select-template-head-wrapper mb-0 card">
        <div class="card-body p-0">
            <div class="select-template-head d-flex justify-content-between p-0 crm-section border-bottom p-2 py-50">
                <div class="col-md-8 col-lg-8 col-sm-12 p-0">
                    <div class="input-group no-box-shadow input-group-merge">
                        <div class="input-group-prepend">
                            <span class="input-group-text border-0"><i data-feather="search"></i></span>
                        </div>
                        <input type="text" class="form-control border-0"
                            [placeholder]="t('Search template field placeholder - (Select template modal) - Search templates')"
                            (keydown.enter)="getTemplates(1,$event.target.value)" />
                    </div>
                </div>
                <div class="d-flex justify-content-end w-100 align-items-center columngap">
                    <div class="col-md-4 col-12 p-0 w-50">
                        <div class="list-group-item mb-0 pb-0 pt-0 px-0">
                            <div class="form-group mb-0">
                                <ng-select [items]="documentTypes | async" bindLabel="document_type" bindValue="id"
                                    [(ngModel)]="selectedDocumentType" [readonly]="false" [searchable]="false"
                                    [placeholder]="t('Filter document type dropdown placeholder - (Select template modal) - Please select type')"
                                    [clearable]="false" (change)="getTemplates(1,'')">
                                </ng-select>
                            </div>
                        </div>
                    </div>
                    <!-- Dont Remove This (Mubashir) will work on the logout section design -->
                    <div class="p-0 logout-btn-crm">
                        <div class="cursor-pointer" (click)="logoutCrmUser()">
                            <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-power" width="30"
                                height="30" viewBox="0 0 24 24" stroke-width="1.5" stroke="#FF2825" fill="none"
                                stroke-linecap="round" stroke-linejoin="round">
                                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                <path d="M7 6a7.75 7.75 0 1 0 10 0" />
                                <path d="M12 4l0 8" />
                            </svg>
                        </div>
                    </div>
                </div>
            </div>
            <app-skeleton *ngIf="loading" [section]="'select-template'" [loop]="0"></app-skeleton>
            
            <div class="select-template-box-wrapper mt-2 mx-2" *ngIf="!loading">
                <!-- Repeat for each template -->
                <div class="d-flex flex-column align-items-center" (fileDropped)="onFileDropped($event)" appDropFiles>
                    <div class="select-template-box position-relative">
                        <input class="fileDrop" type="file" #uploadFileInput (change)="onFileDropped($event)"
                            [accept]="acceptableFiles" />
                        <i size="25" class="me-50 feather icon-plus upload-icon-crm align-middle"></i>
                    </div>
                  <div class="fw-bold card-title">{{t("Iframeable upload Pdf box text (Iframeable upload pdf) - Upload PDF")}}</div>
                </div>

                <div class="d-flex flex-column align-items-center" *ngFor="let template of templateListing" (click)="goToSendDocument(template,template.template.id)">
                    <div class="select-template-box">
                        <ng-container *ngIf="template.template.thumbnail; else noThumbnail">
                            <img class="card-img card-img-left" [src]="template.template.id | thumbnail: 'templates' "
                                alt="Thumbnail">
                        </ng-container>
                        <ng-template #noThumbnail>
                            <div class="no-thumbnail"></div>
                        </ng-template>
                    </div>
                    <h6 class="fw-bold d-block text-nowrap card-title mb-0">{{ template?.template?.name }}</h6>
                    <small class="mt-25 card-subtitle">{{(template.template_details?.document_type_id | getDocumentType) | async}}</small>
                </div>
            </div>
        </div>
        <div class="template-pagination-row">
            @if(pagination){
                <ngb-pagination class="float-end px-1" (pageChange)="getTemplates($event)" [collectionSize]="pagination.total" [(page)]="page"
                    [maxSize]="3" aria-label="Default pagination">
                    <ng-template ngbPaginationPrevious>
                        <span [data-feather]="'chevron-left'" [size]="18" [class]="'fw-bolder'"></span>
                    </ng-template>
                    <ng-template ngbPaginationNext>
                        <span [data-feather]="'chevron-right'" [size]="18" [class]="'fw-bolder'"></span>
                    </ng-template>
                </ngb-pagination>   
            }
        </div>
    </div>
</ng-container>